import { InjectionMoldingOrderedProductStatus, isInjectionMoldingProductionCompleteStatus } from '../enums/injection-molding-ordered-product-status.enum';
import { InjectionMoldingOrders_UserAbilities } from '../models/user-abilities.model';

export function canTransitionInjectionMoldingOrderedProductStatus(
    from: InjectionMoldingOrderedProductStatus,
    to: InjectionMoldingOrderedProductStatus,
    abilities: Pick<
        InjectionMoldingOrders_UserAbilities,
        'CanReleaseOrderedProducts'
        | 'CanSetReadyToShipOrderedProducts'
        | 'CanCompleteOrderedProducts'
        | 'CanHoldOrCancelOrderedProducts'
    >,
    productionIsComplete = true,
): boolean {
    if (from === to) return false;
    if (from === InjectionMoldingOrderedProductStatus.Complete
        || from === InjectionMoldingOrderedProductStatus.Canceled) return false;

    if (to === InjectionMoldingOrderedProductStatus.Canceled) {
        return abilities.CanHoldOrCancelOrderedProducts;
    }
    if (from === InjectionMoldingOrderedProductStatus.Draft
        && to === InjectionMoldingOrderedProductStatus.Released) {
        return abilities.CanReleaseOrderedProducts;
    }
    if (from === InjectionMoldingOrderedProductStatus.Released
        && to === InjectionMoldingOrderedProductStatus.ProductionComplete) {
        return abilities.CanSetReadyToShipOrderedProducts && productionIsComplete;
    }
    if (isInjectionMoldingProductionCompleteStatus(from)
        && to === InjectionMoldingOrderedProductStatus.Released) {
        return abilities.CanSetReadyToShipOrderedProducts;
    }
    if (isInjectionMoldingProductionCompleteStatus(from)
        && to === InjectionMoldingOrderedProductStatus.Complete) {
        return abilities.CanCompleteOrderedProducts;
    }
    if (from === InjectionMoldingOrderedProductStatus.Released
        && to === InjectionMoldingOrderedProductStatus.Hold) {
        return abilities.CanHoldOrCancelOrderedProducts;
    }
    if (from === InjectionMoldingOrderedProductStatus.Hold
        && to === InjectionMoldingOrderedProductStatus.Released) {
        return abilities.CanHoldOrCancelOrderedProducts;
    }
    return false;
}

export function getAllowedInjectionMoldingOrderedProductStatuses(
    from: InjectionMoldingOrderedProductStatus,
    abilities: Pick<
        InjectionMoldingOrders_UserAbilities,
        'CanReleaseOrderedProducts'
        | 'CanSetReadyToShipOrderedProducts'
        | 'CanCompleteOrderedProducts'
        | 'CanHoldOrCancelOrderedProducts'
    >,
    productionIsComplete = true,
): InjectionMoldingOrderedProductStatus[] {
    return Object.values(InjectionMoldingOrderedProductStatus).filter((to) => (
        to !== InjectionMoldingOrderedProductStatus.ReadyToShip &&
        canTransitionInjectionMoldingOrderedProductStatus(from, to, abilities, productionIsComplete)
    ));
}
